<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">

    <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->

    <div id="user-data" >


     <div >
       
      
     </div>

      <!-- Permissions -->
      <vx-card title="Atribuição de Permissões a Funções">

        <div class="vx-row">
            <div class="vx-col w-1/2  mb-5" >
      <v-select :disabled="!roleAdministrador"  placeholder="Seleccione a Role" :options="roles" label="name" v-model="selectedRole"></v-select>
         <!-- {{ selectedRole }} -->
    </div>
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Permissões</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <div class="block overflow-x-auto">
          <table class="w-full permissions-table">
            <tr>
              <!--
                You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
                our data structure. You just have to loop over above variable to get table headers.
                Below we made it simple. So, everyone can understand.
               -->
              <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Módulo', 'Leitura', 'Escrita', 'Actualização', 'Eliminar', 'Aprovação']" :key="heading">{{ heading }}</th>
            </tr>

            <!-- <tr v-for="(val, name) in user_data.permissions" :key="name">
              <td class="px-3 py-2">{{ name }}</td>
              <td v-for="(permission, name) in val" class="px-3 py-2" :key="name+permission">
                <vs-checkbox v-model="val[name]" class="pointer-events-none" />
              </td>
            </tr> -->
          
 <tr >
              <td class="px-3 py-2">Funcionarios</td>
              <td class="px-1 py-2">
                <!-- <vs-checkbox vs-value="list Employee" v-model="permission_name" class="pointer-events" /> -->
                <vs-checkbox :disabled="!roleAdministrador" vs-value="list Employee" v-model="canListEmp" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Employee" v-model="canAddEmp" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Employee" v-model="canUpdateEmp" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Employee" v-model="canDeleteEmp" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Employee" v-model="canApproveEmp" class="pointer-events" />
              </td>
            </tr>

             <tr >
                 <td class="px-3 py-2">Assiduidade</td>
              <td class="px-1 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="list Attendance" v-model="canListAttendance" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Attendance" v-model="canAddAttendance" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Attendance" v-model="canUpdateAttendance" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Attendance" v-model="canDeleteAttendance" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Attendance" v-model="canApproveAttendance" class="pointer-events" />
              </td>
            </tr>

            <!-- <tr >
                <td class="px-3 py-2">Licenças</td>
              <td class="px-1 py-2">
                <vs-checkbox vs-value="list Employee" v-model="ok" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox vs-value="create Employee" v-model="ok" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox vs-value="update Employee" v-model="ok" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox vs-value="delete Employee" v-model="ok" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox vs-value="approve Employee" v-model="ok" class="pointer-events" />
              </td>
            </tr> -->
            

              <tr >
                  <td class="px-3 py-2">Processamento <br> de salários</td>
              <td class="px-1 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="list Payroll" v-model="canListPayroll" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Payroll" v-model="canAddPayroll" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Payroll" v-model="canUpdatePayroll" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Payroll" v-model="canDeletePayroll" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Payroll" v-model="canApprovePayroll" class="pointer-events" />
              </td>
            </tr>
            
          </table>
        </div>
 <div  class="vx-row" v-if="roleAdministrador">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button  class="ml-auto  mt-2" type="border" color="warning" @click="removerPermissao">Remover</vs-button>
          <vs-button   class="ml-4 mt-2" @click="saveData" >Adicionar</vs-button>
        </div>
      </div>
    </div>
      </vx-card>
      
    </div>
  </div>
</template>

<script>
import http from '../../../../http-common';
import vSelect from 'vue-select'
import { PermissionsMixin } from "../../../mixins/permissions"

export default {
  mixins:[PermissionsMixin],
    components: {
    vSelect
  },
  data() {
    return {
     roles:[],
     selectedRole:"",
     permission_name:[],
     err:"",
      newArray:[],
     currentUser:[],

     /////////////////////////////PERMISSOES//////////////////////////////


     canListEmp: false,
     canAddEmp: false,
     canUpdateEmp: false,
     canDeleteEmp: false,
     canApproveEmp:false,

       canListAttendance: false,
     canAddAttendance: false,
     canUpdateAttendance: false,
     canDeleteAttendance: false,
     canApproveAttendance:false,

     canListPayroll: false,
     canAddPayroll: false,
     canUpdatePayroll: false,
     canDeletePayroll: false,
     canApprovePayroll:false,



    }
  },

    mounted() {
    this.initialize();
  },

  methods: {
    initialize(){
      this.getRoles();
    },
   

    getRoles() {
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      http
      .get("/permissions/roles", config)
        .then((success) => {
          this.roles = success.data
        })
        .catch((error) => {
          error;
          
         
        });
    },

    clean(){
      this.permission_name=[]
    },

    saveData() {
        if(this.canListEmp !=true){
this.permission_name.push(this.canListEmp);
        }

         if(this.canAddEmp !=true){
this.permission_name.push(this.canAddEmp);
        }
           if(this.canUpdateEmp !=true){
this.permission_name.push(this.canUpdateEmp);
        }

           if(this.canDeleteEmp !=true){
this.permission_name.push(this.canDeleteEmp);
        }
      
        if(this.canApproveEmp !=true){
this.permission_name.push(this.canApproveEmp);
        }

//////////////////////////////////////////////////////////////
if(this.canListAttendance !=true){
this.permission_name.push(this.canListAttendance);
        }

         if(this.canAddAttendance !=true){
this.permission_name.push(this.canAddAttendance);
        }
           if(this.canUpdateAttendance !=true){
this.permission_name.push(this.canUpdateAttendance);
        }

           if(this.canDeleteAttendance !=true){
this.permission_name.push(this.canDeleteAttendance);
        }
      
        if(this.canApproveAttendance !=true){
this.permission_name.push(this.canApproveAttendance);
        }
///////////////////////////////////////////////////////////////


if(this.canListPayroll !=true){
this.permission_name.push(this.canListPayroll);
        }

         if(this.canAddPayroll !=true){
this.permission_name.push(this.canAddPayroll);
        }
           if(this.canUpdatePayroll !=true){
this.permission_name.push(this.canUpdatePayroll);
        }

           if(this.canDeletePayroll !=true){
this.permission_name.push(this.canDeletePayroll);
        }
      
        if(this.canApprovePayroll !=true){
this.permission_name.push(this.canApprovePayroll);
        }


            this.$vs.loading()
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        permission_name:this.permission_name,

      };
      this.$validator.validateAll();
    http
        .post(`/permissions/permission_to_roles/${this.selectedRole.id}`, data, config)
        .then((success) => {
          success;
          this.clean()
          this.getRoles();
          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Permissao  atribuida com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
            this.$vs.loading.close();
             this.err= error.response.data
          
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao salvar permissao ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },


    removerPermissao() {
      //////////////////////////permissoes de funcionario//////////////////
       if(this.canListEmp !=true){
this.permission_name.push("list Employee");
        }

         if(this.canAddEmp !=true){
this.permission_name.push("create Employee");
        }
           if(this.canUpdateEmp !=true){
this.permission_name.push("update Employee");
        }

           if(this.canDeleteEmp !=true){
this.permission_name.push("delete Employee");
        }
      
        if(this.canApproveEmp !=true){
this.permission_name.push("approve Employee");
        }
          //////////////////////////permissoes de EFECTIVIDADE//////////////////
       if(this.canListAttendance !=true){
this.permission_name.push("list Attendance");
        }

         if(this.canAddAttendance !=true){
this.permission_name.push("create Attendance");
        }
           if(this.canUpdateAttendance !=true){
this.permission_name.push("update Attendance");
        }

           if(this.canDeleteAttendance !=true){
this.permission_name.push("delete Attendance");
        }
      
        if(this.canApproveAttendance !=true){
this.permission_name.push("approve Attendance");
        }
                //////////////////////////permissoes de FOLHA//////////////////
       if(this.canListPayroll !=true){
this.permission_name.push("list Payroll");
        }

         if(this.canAddPayroll !=true){
this.permission_name.push("create Payroll");
        }
           if(this.canUpdatePayroll !=true){
this.permission_name.push("update Payroll");
        }

           if(this.canDeletePayroll !=true){
this.permission_name.push("delete Payroll");
        }
      
        if(this.canApprovePayroll !=true){
this.permission_name.push("approve Payroll");
        }




      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        permission_name:this.permission_name,

      };
      this.$validator.validateAll();
    http
        .post(`/permissions/remove_role_permissions/${this.selectedRole.id}`, data, config)
        .then((success) => {
          success;
          this.clean()
          
          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Permissões Removidas com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
             this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao salvar ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },


        verifyPermissions(){
          this.canListEmp=this.canAddEmp=this.canUpdateEmp=this.canDeleteEmp=this.canApproveEmp= this.canListAttendance=this.canAddAttendance=this.canUpdateAttendance=this.canDeleteAttendance=this.canApproveAttendance=this.canListPayroll=this.canAddPayroll=this.canUpdatePayroll=this.canDeletePayroll=this.canApprovePayroll=false;//aumente a lista de variaveis aqui

       for(let permission in this.selectedRole.permissions){
          if(this.selectedRole.permissions[permission].name == "list Employee"){
            this.canListEmp = true;
          }
           if(this.selectedRole.permissions[permission].name == "create Employee"){
            this.canAddEmp = true;
          }
          if(this.selectedRole.permissions[permission].name == "update Employee"){
            this.canUpdateEmp = true;
          }
           if(this.selectedRole.permissions[permission].name == "delete Employee"){
            this.canDeleteEmp = true;
          }
           if(this.selectedRole.permissions[permission].name == "approve Employee"){
            this.canApproveEmp = true;
          }


           /////////////////////////EFECTIVIDADE
           if(this.selectedRole.permissions[permission].name == "list Attendance"){
            this.canListAttendance = true;
          }
           if(this.selectedRole.permissions[permission].name == "create Attendance"){
            this.canAddAttendance = true;
          }
          if(this.selectedRole.permissions[permission].name == "update Attendance"){
            this.canUpdateAttendance = true;
          }
           if(this.selectedRole.permissions[permission].name == "delete Attendance"){
            this.canDeleteAttendance = true;
          }
           if(this.selectedRole.permissions[permission].name == "approve Attendance"){
            this.canApproveAttendance = true;
          }

            /////////////////////////PROCESSAR SALARIO
           if(this.selectedRole.permissions[permission].name == "list Payroll"){
            this.canListPayroll = true;
          }
           if(this.selectedRole.permissions[permission].name == "create Payroll"){
            this.canAddPayroll = true;
          }
          if(this.selectedRole.permissions[permission].name == "update Payroll"){
            this.canUpdatePayroll = true;
          }
           if(this.selectedRole.permissions[permission].name == "delete Payroll"){
            this.canDeletePayroll = true;
          }
           if(this.selectedRole.permissions[permission].name == "approve Payroll"){
            this.canApprovePayroll = true;
          }
        }
    }

  
},
 watch: {
        selectedRole() {
            this.verifyPermissions()
      }
}

  
}



</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
